import { getUserFromToken } from "@core/index";
import { PaginationAndColumnVisibilityHoc } from "@shared/components";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import RoleManagementGrid from "../components/RoleManagementGrid";
import RoleManagementHeader from "../components/RoleManagementHeader";
import { ColumnOptions, DefaultHiddenColumns } from "../utils/constants";

const RoleManagementPage = ({
  visibleColumns,
  setVisibleColumns,
  paginationModel,
  setPaginationModel,
}) => {
  const navigate = useNavigate();
  const user = getUserFromToken();
  const [canAccess, setCanAccess] = useState(false);

  useEffect(() => {
    const hasAccess = user && user.role === "admin";
    if (!hasAccess) {
      navigate("/", { replace: true });
    } else {
      setCanAccess(true);
    }
  }, [user, navigate]);

  if (!canAccess) {
    return null;
  }

  return (
    <>
      <RoleManagementHeader
        visibleColumns={visibleColumns}
        setVisibleColumns={setVisibleColumns}
        setPaginationModel={setPaginationModel}
      />
      <RoleManagementGrid
        visibleColumns={visibleColumns}
        setPaginationModel={setPaginationModel}
        paginationModel={paginationModel}
      />
    </>
  );
};

// Map column options to match the expected format in HOC
const transformedColumnOptions = ColumnOptions.map((option) => ({
  ...option,
  field: option.value,
}));

const TransformedRoleManagementPage = PaginationAndColumnVisibilityHoc(
  RoleManagementPage,
  {
    columnOptions: transformedColumnOptions,
    defaultHiddenColumns: DefaultHiddenColumns,
    storageKey: "roleManagementVisibleColumns",
  }
);

export default TransformedRoleManagementPage;
